<template>
  <div class="lottery">
    <van-nav-bar
      :border="false"
      style="
        width: 100%;
        background: linear-gradient(90deg, #df35adcc, #4f1db5cc);
      "
    >
      <template #title>
        <span style="color: #fff">{{ lottery.name }}</span>
      </template>
      <template #left>
        <van-icon @click="back()" name="arrow-left" color="#fff" size="24" />
      </template>
      <template #right>
        <van-icon @click="onClickRight" name="bars" color="#fff" size="24" />
      </template>
    </van-nav-bar>
    <div class="history" style="z-index: 2011" v-show="isshowhistory">
      <div class="" >
        <div class="left">
          <p style="text-align: center;">{{ $t('reservation.bearer') }}</p>
          <ul>
            <li v-for="(item,index) in lottery_list" :key="index">{{ item.expect }}</li>
          </ul>
        </div>
        <div class="right">
          <p style="text-align: center">{{ $t('reservation.data') }}</p>
          <ul>
            <li class="mak" v-for="(item,index) in lottery_list" :key="index">
              <div class="ball">
                <span :class="'idem'+v" v-for="(v,i) in item.opencode" :key="i" />
              </div>
              <div class="res"><span>{{ getsum(item) }}</span><span>{{ getsize(item) }}</span><span>{{getdouble(item)}}</span></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="top">
      <div class="qs">
        <div>
          <div class="ico">&nbsp;<img alt="" :src="lottery.ico" /></div>
          <h1>{{ lottery.next_expect }}</h1>
        </div>
        <span style="font-size: 13px"
          ><span
            style="
              font-size: 13px;
              color: rgb(255, 255, 255);
              margin-right: 10px;
            "
            >{{ $t('reservation.time') }}:
          </span>
          <van-count-down :time="time" @finish="check()" />
          &nbsp;
        </span>
      </div>
      <div class="number">
        <div class="left">
          <div class="ball">
            <p>
              {{ lottery.now_expect }} <br />
              {{ $t('reservation.round') }}
            </p>
          </div>
        </div>
        <div class="right">
          <div class="res"><span>{{ sum }}</span><span>{{ size }}</span><span>{{ double }}</span></div>
          <van-icon
            v-if="!isshowhistory"
            name="arrow-down"
            @click="isshowhistory = !isshowhistory"
          />
          <van-icon
            v-else
            name="arrow-up"
            @click="isshowhistory = !isshowhistory"
          />
        </div>
      </div>
    </div>
    <div class="lottery-content">
      <div class="right" id="toBottom">
        <div class="ball" id="eidet">
          <div v-if="lottery_peilv_list_1">
            <div
              class="idx0"
              v-for="(item, index) in lottery_peilv_list_1"
              :key="index"
              @click="choosePlay(item.type,item.name);"
              :class="{active:choose[item.type]}"
            >
              <img :src="item.img" class="button-bg-img" />
              <p class="bet-label">{{ item.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mask animate__animated animate__fadeInUp" v-if="formData.length > 0">
      <div class="title">
        <p>{{ $t('reservation.curr_choose') }}: <span v-for="(v,i) in formData" :key="i">{{ v.name }}&nbsp;</span></p>
        <div>
          <i class="van-badge__wrapper van-icon van-icon-arrow"></i
          ><i class="van-badge__wrapper van-icon van-icon-arrow"></i>
        </div>
      </div>
      <div class="c1">
        <p>{{ $t('reservation.quantity') }}:</p>
        <input type="number" v-model="money" />
        <p></p>
      </div>
      <div class="c2">
        <p>
            {{ $t('reservation.total') }} <span>{{ formData.length }}</span> {{ $t('reservation.unit') }}
          <span>{{ parseInt(money) * formData.length }}</span>
        </p>
      </div>
    </div>
    <div class="foot base-footer" style="width: calc(100% - 6%) !important">
      <p>{{ $t('reservation.poinnts') }} <span>{{ userInfo.money }}</span></p>
      <a @click="doSub">{{ $t('reservation.submit') }}</a>
    </div>
    <van-popup v-model="showmore" position="right" :style="{ height: '100vh' }">
      <div  class="more-products-popup">
        <div  class="popup-title">{{ $t('reservation.morepro') }}</div>
        <div  class="more-products-list">
          <div @click="choosePlay(item.type,item.name);" class="more-product-item" :class="{active:choose[item.type]}" v-for="(item,index) in lottery_peilv_list_2" :key="index">
            <img
              
              :src="item.img"
              class="more-product-img"
            /><span  class="more-product-name">{{ item.name }}</span
            ><i v-if="choose[item.type]"
              
              class="van-badge__wrapper van-icon van-icon-success"
              style="color: rgb(208, 122, 199); font-size: 24px"
              ><!----><!----><!----></i
            >
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
var time;
var count = 0;
export default {
  name: "LotteryView",
  data() {
    return {
      jiesuanpage: false,
      choose: {
        bi: false,
        sm: false,
        si: false,
        do: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false,
        10: false,
        11: false,
        12: false,
        13: false,
        14: false,
        15: false,
        16: false,
        17: false,
        18: false,
      },
      defaultvalue: [
        { key: "25", value: 25 },
        { key: "100", value: 100 },
        { key: "500", value: 500 },
        { key: "1K", value: 1000 },
        { key: "2.5K", value: 2500 },
        { key: "5K", value: 5000 },
      ],
      showmoneyindex: 0,
      playgame: false,
      shopping: false,
      isLoading: false,
      play: {},
      lottery_peilv_list_1: {},
      lottery_peilv_list_2: {},
      lottery_peilv_list: {},
      lottery_list: {},
      active: false,
      userInfo: {},
      lottery: {},
      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",
      sum: 0,
      size: "",
      double: "",
      time: 0,
      shopchoose: this.$t("reservation.no_choose"),
      gameitem: "",
      formData: [],
      money: "0",
      isshowhistory: false,
      showmore: false,
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onClickRight() {
      this.showmore = true;
    },
    doSub() {
      if (this.money === "0") {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if (this.userInfo.money - this.money * this.formData.length < 0) {
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        } else {
          const todusubdata = {
            item: this.gameitem,
            money: this.money,
            lid: this.lottery.id,
            mid: this.userInfo.id,
            expect: this.lottery.now_expect,
          };

          this.$http({
            method: "post",
            data: todusubdata,
            url: "game_place_order",
          }).then((res) => {
            if (res.code === 200) {
              this.$toast(res.msg);
              this.allClear();
              this.getUserInfo();
            } else if (res.code === 401) {
              this.$toast(res.msg);
            }
          });
          return true;
        }
      }
    },
    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]["type"]] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem = "";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        this.jiesuanpage
          ? (this.jiesuanpage = false)
          : (this.jiesuanpage = true);
      }
    },
    clearChooes(type) {
      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i]["type"]) {
          this.formData.splice(i, 1);
          this.choose[type] = false;
        }
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },
    choosePlay(type, name) {
      
      if (this.choose[type] === true) {
        this.choose[type] = false;
        for (var i = 0; i < this.formData.length; i++) {
          if (type === this.formData[i]["type"]) {
            this.formData.splice(i, 1);
          }
        }
      } else if (this.choose[type] === false) {
        if(this.formData.length > 1){
            this.$toast(this.$t('reservation.itemerror'))
            return
        }
        this.formData.push({ name: name, type: type });
        this.choose[type] = true;
      }

      if (this.formData.length >= 1) {
        this.shopping = true;
        if (this.money === "" || this.money === 0) {
          //this.clickmoney(0)
        }
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
    },
    clickmoney(index) {
      this.showmoneyindex = index;
      this.money = this.defaultvalue[index].value;
    },
    check() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        time = window.setInterval(() => {
          setTimeout(() => {
            this.getUserInfo();
            this.getLotteryInfo();
            this.getLotteryList();
            count++;
            if (count > 5) {
              clearInterval(time);
              count = 0;
            }
          }, 0);
        }, 300);
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryPeilv() {
      this.$http({
        method: "get",
        data: { id: this.$route.query.id },
        url: "lottery_get_peilv",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_peilv_list = res.data;
          this.lottery_peilv_list_1 = res.data.slice(0, 4);
          this.lottery_peilv_list_2 = res.data.slice(4)
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryList() {
      this.$http({
        method: "get",
        data: { key: this.$route.query.key },
        url: "lottery_get_one_list",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_list = res.data;
          console.log(res.data);
          this.getLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryInfo() {
      this.$http({
        method: "get",
        data: { key: this.$route.query.key },
        url: "lottery_get_info",
      }).then((res) => {
        if (res.code === 200) {
          if (
            parseFloat(this.userInfo.money) < parseFloat(res.data.condition)
          ) {
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({ path: "/home" });
            return false;
          }
          this.lottery = res.data;
          this.time = res.data.second * 1000;

          if (this.time / 1000 === 59) {
            this.$toast(
              this.$t("reservation.prize_succ") + this.lottery.now_expect
            );
          }
          
          this.shanzi_1 =
            res.data?.opencode[0]
          this.shanzi_2 =
             res.data?.opencode[1]
          this.shanzi_3 =
         res.data?.opencode[2] 
            
          this.sum =
            res.data.opencode[0] + res.data.opencode[1] + res.data.opencode[2];
            
          if (this.sum >= 11 && this.sum <= 18) {
            this.size = "A";
          } else if (this.sum >= 3 && this.sum <= 10) {
            this.size = "B";
          }
          if (this.sum % 2 === 0) {
            this.double = "D";
          } else {
            this.double = "C";
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getsum(item){
        return item.opencode[0] + item.opencode[1] + item.opencode[2];
    },
    getsize(item){
        const sum = this.getsum(item)
        if (sum >= 11 && sum <= 18) {
            return "A";
          } else if (sum >= 3 && sum <= 10) {
            return "B";
          }
    },
    getdouble(item){
        const sum = this.getsum(item)
        return sum % 2 == 0 ? 'D':'C'
    }
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/login" });
    } else {
      this.getUserInfo();
      this.getLotteryInfo();
      this.getLotteryList();
    }
  },
  destroyed() {
    clearInterval(time);
  },
};
</script>
<style lang="scss" scoped>
.lottery {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: url("../../assets/img/home/233.ebf5fe94.png") no-repeat top / 100%;
  position: absolute;
  .top {
    width: calc(100% - 20px);
    padding: 1rem 10px 0.66667rem;
    position: relative;
    z-index: 10;
    background: linear-gradient(90deg, #df35adcc, #4f1db5cc);
    .qs {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 0.46667rem;
      div {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .ico {
          width: 3.33333rem;
          height: 3.33333rem;
          overflow: hidden;
          img {
            width: 100%;
          }
        }
        h1 {
          font-size: 0.96667rem;
          color: #fff;
          padding-left: 0.66667rem;
        }
      }
      span {
        color: #f4d70a;
        font-size: 1.1rem;
        display: flex;
        .van-count-down {
          color: #f4d70a;
          font-size: 1.1rem;
        }
      }
    }
  }
}

.lottery .top .number {
  padding: 0.66667rem;
  background: #f47cd5;
}

.lottery .top .number .right,
.lottery .top .number {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0.26667rem;
}

.lottery .top .number .right {
  width: 60%;
  background: #fff;
  height: 2.66667rem;
  padding: 0 0.66667rem;
  position: relative;
}

.lottery .top .number .right:before {
  content: "";
  position: absolute;
  left: -1rem;
  width: 2px;
  height: 2rem;
  background: #f9b1e7;
}

.lottery .top .number .right .res {
  display: flex;
  justify-content: center;
  align-items: center;
}

.lottery .top .number .right .res span {
  width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: #fff;
  margin-right: 0.86667rem;
  background: linear-gradient(90deg, #8b73e6, #d75db4);
}

.lottery .top .number .left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.lottery .top .number .left .res {
  width: 6.66667rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 0.33333rem;
}

.lottery .top .number .left .res span {
  font-size: 0.93333rem;
  font-weight: 600;
}

.lottery .top .number .left .ball,
.lottery .top .number .left .ball p {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.lottery .top .number .left .ball p {
  height: 1.8rem;
  width: 6.93333rem;
  font-size: 0.8rem;
  color: #fff;
  font-weight: 600;
}

.lottery .top .number .left .ball span {
  width: 2.33333rem;
  height: 2.33333rem;
}

.lottery .top .number .left .ball span.idem4 {
  background: url(../../assets/img/home/4.png) no-repeat 50%/100%;
}

.lottery .top .number .left .ball span.idem1 {
  background: url(../../assets/img/home//1.png) no-repeat 50%/100%;
}

.lottery .top .number .left .ball span.idem2 {
  background: url(../../assets/img/home/2.png) no-repeat 50%/100%;
}

.lottery .top .number .left .ball span.idem3 {
  background: url(../../assets/img/home/3.png) no-repeat 50%/100%;
}

.lottery .top .number .left .ball span.idem5 {
  background: url(../../assets/img/home/5.png) no-repeat 50%/100%;
}

.lottery .top .number .left .ball span.idem6 {
  background: url(../../assets/img/home/6.png) no-repeat 50%/100%;
}

.lottery .history {
  position: absolute;
  width: 100%;
  height: calc(100% - 11.66667rem);
  background: #0003;
  z-index: 9;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.lottery .history > div {
  overflow-y: auto;
  width: 100%;
  height: 20rem;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-top: 0.66667rem;
}

.lottery .history > div > div p {
  font-size: 0.76667rem;
  font-weight: 600;
}

.lottery .history > div > div ul {
  width: 100%;
  padding-top: 0.66667rem;
}

.lottery .history > div > div ul li {
  width: 100%;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.lottery .history > div .left {
  width: 7.33333rem;
}

.lottery .history > div .right {
  flex: 1;
  background: #fff;
}

.lottery .history > div .right ul li .res {
  width: 6.66667rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 1.33333rem;
}

.lottery .history > div .right ul li .res span {
  font-size: 0.8rem;
  font-weight: 600;
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 1.66667rem;
  height: 1.66667rem;
}

.lottery .history > div .right ul li .ball {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.lottery .history > div .right ul li .ball p {
  height: 1.8rem;
  width: 6.93333rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 0.76667rem;
  color: #9b9a9a;
}

.lottery .history > div .right ul li .ball span {
  width: 1.8rem;
  height: 1.8rem;
  margin-right: 0.5rem;
}

.lottery .history > div .right ul li .ball span.idem4 {
  background: url(../../assets/img/home/4.png) no-repeat 50%/100%;
}

.lottery .history > div .right ul li .ball span.idem1 {
  background: url(../../assets/img/home/1.png) no-repeat 50%/100%;
}

.lottery .history > div .right ul li .ball span.idem2 {
  background: url(../../assets/img/home/2.png) no-repeat 50%/100%;
}

.lottery .history > div .right ul li .ball span.idem3 {
  background: url(../../assets/img/home/3.png) no-repeat 50%/100%;
}

.lottery .history > div .right ul li .ball span.idem5 {
  background: url(../../assets/img/home/5.png) no-repeat 50%/100%;
}

.lottery .history > div .right ul li .ball span.idem6 {
  background: url(../../assets/img/home/6.png) no-repeat 50%/100%;
}

.lottery .lottery-content {
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: #f0f0f0;
  overflow: hidden;
}

.lottery .lottery-content .left {
  width: 6.06667rem;
  height: 100%;
  background: #fff;
  padding-top: 1rem;
  border-top: 1rem solid #f0f0f0;
  display: none;
}

.lottery .lottery-content .left .item {
  width: 100%;
}

.lottery .lottery-content .left .item:first-child span {
  border-radius: 0 0.33333rem 0 0;
}

.lottery .lottery-content .left .item span {
  width: 100%;
  background: #f3cb76;
  color: #fff;
  display: inline-block;
  font-size: 0.83333rem;
  padding: 0.66667rem 0;
}

.lottery .lottery-content .left .item > .slide {
  padding: 1rem 0;
  background: #fff;
}

.lottery .lottery-content .left .item > .slide.active {
  background: #ece6eb;
  color: #7e5678;
  position: relative;
  overflow: hidden;
}

.lottery .lottery-content .left .item > .slide.active:after {
  content: "";
  position: absolute;
  width: 1rem;
  height: 1rem;
  right: -0.66667rem;
  top: 0;
  bottom: 0;
  margin: auto;
  background: #fff;
  transform: rotate(50deg);
}

.lottery .lottery-content .right {
  flex: 1;
  height: 100%;
  overflow-y: auto;
}

.lottery .lottery-content .right .ball {
  align-items: center;
  padding: 5% 0px 4rem;
  position: relative;
}

.lottery .lottery-content .right .ball > div,
.lottery .lottery-content .right .ball {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.lottery .lottery-content .right .ball > div .idx0 {
  width: 45%;
  height: 5rem;
  border-radius: 0.33333rem;
  margin-bottom: 15%;
  //box-shadow: 0 0 0.33333rem #0000001a;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  padding: 0.5rem;
  text-align: center;
}

.lottery .lottery-content .right .ball > div .idx0.active {
  background: #d07ac7;
}

.lottery .lottery-content .right .ball > div .idx0.active:after {
  opacity: 0.2;
}

.lottery .lottery-content .right .ball > div .idx0.active p {
  color: #d07ac7;
}

.lottery .lottery-content .right .ball > div .idx0 p {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  padding: 0;
}

.lottery .lottery-content .right .ball > div .idx0 .bet-label {
  position: absolute;
  font-size: 1rem;
  font-weight: 700;
  bottom: -1.5rem;
  color: red;
}

.lottery .lottery-content .right .ball > div .idx0 .button-bg-img {
  position: absolute;
  top: 0;
  left: 5%;
  width: 90%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.33333rem;
  z-index: 1;
}

.lottery .lottery-content .right .ball .idx1 {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  padding-top: 1.33333rem;
}

.lottery .lottery-content .right .ball .idx1.ebth {
  display: flex;
  flex-direction: column;
  padding-top: 0;
}

.lottery .lottery-content .right .ball .idx1.ebth > div {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  position: relative;
  padding-top: 2rem;
  padding-bottom: 0.66667rem;
}

.lottery .lottery-content .right .ball .idx1.ebth > div > div {
  width: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5%;
}

.lottery .lottery-content .right .ball .idx1.ebth > div > div.active p {
  background: #d07ac7;
  color: #fff;
}

.lottery .lottery-content .right .ball .idx1.ebth > div > span {
  position: absolute;
  top: 0;
  left: 0;
  color: #b4b4b5;
}

.lottery .lottery-content .right .ball .idx1 > span {
  position: absolute;
  top: 0.66667rem;
  left: 0.66667rem;
  color: #b4b4b5;
}

.lottery .lottery-content .right .ball .idx1 > div {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
  margin-bottom: 5%;
}

.lottery .lottery-content .right .ball .idx1 > div.active p {
  background: #ff253f;
  color: #fff;
}

.lottery .lottery-content .right .ball .idx1 > div p {
  width: 3.33333rem;
  height: 3.33333rem;
  background: #fff;
  color: #7d7c7c;
  border-radius: 50%;
  font-size: 1.03333rem;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 0.33333rem #0000000a;
}
</style>
<style scoped>
.lottery .mask {
  position: absolute;
  bottom: 0;
  min-height: 9rem;
  width: calc(100% - 6%);
  background: #fff;
  box-shadow: 0 -0.13333rem 0.13333rem #00000012;
  padding: 0 3%;
  z-index: 9999;
}

.lottery .mask .title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.33333rem 0;
}

.lottery .mask .title p {
  color: #3b3597;
}

.lottery .mask .title span {
  color: #ed37ae;
  font-size: 0.86667rem;
}

.lottery .mask .title > div i {
  color: #ff253f;
  font-size: 0.86667rem;
}

.lottery .mask .title > div i:first-child {
  position: relative;
  left: 0.6rem;
}

.lottery .mask .c1 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0.33333rem 0;
  color: #3b3597;
}

.lottery .mask .c1 input {
  text-align: center;
  border: 0;
  background: #f2f2f5;
  padding: 0.33333rem 0;
  margin: 0 0.33333rem;
  width: 8.33333rem;
}

.lottery .mask .c1 span {
  min-width: 6.66667rem;
}

.lottery .mask .c2 {
  border-top: 1px solid #f7f8f9;
  padding: 0.33333rem 0;
  margin-top: 0;
}

.lottery .mask .c2 p {
  text-align: left;
  color: #3d359c;
}

.lottery .mask .c2 p span {
  color: #ed50b2;
  padding: 0 0.33333rem;
}

.lottery .mask .c2 .cm {
  display: flex;
  justify-content: space-between;
  padding: 0.66667rem 0;
}

.lottery .mask .c2 .cm > div {
  width: 16.666%;
  height: 2.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #a063ee;
  background: url(data:image/png;base64,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)
    no-repeat 50% 50% / auto 100%;
}

.lottery .mask .c2 .cm > div.active {
  color: #fff;
  background: url(data:image/png;base64,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)
    no-repeat 50% / auto 100%;
}

@keyframes moves-548d6309-22ee45ad {
  0% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.lottery .foot {
  position: fixed;
  bottom: 0;
  width: calc(100% - 6%);
  height: 3.2rem;
  background: #fff;
  padding: 0 3%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 9999;
}

.lottery .foot p {
  padding-right: 0.66667rem;
  font-size: 0.86667rem;
  color: #302697;
}

.lottery .foot p span {
  color: #ef41b1;
  padding: 0 0.33333rem;
}

.lottery .foot a {
  background: linear-gradient(20deg, #8673e5, #d958a4);
  color: #fff;
  border-radius: 0.33333rem;
  padding: 0.53333rem 1.33333rem;
  font-size: 1rem;
}



.more-products-popup {
    width: calc(100% - 2rem);
    height: 100%;
    background: #f5f5f5;
    padding: 1rem;
}

.popup-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: #333;
    padding: 1rem 0;
    border-bottom: 2px solid #e0e0e0;
    margin-bottom: 1rem
}

.more-products-list {
    display: flex;
    flex-direction: column;
    gap: .8rem;
}

.more-product-item {
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: .5rem;
    padding: .8rem;
    box-shadow: 0 2px 8px #0000001a;
    transition: all .3s ease;
    cursor: pointer
}

.more-product-item.active {
    background: #f3e5f5;
    border: 2px solid #d07ac7
}

.more-product-img {
    width: 3.5rem;
    height: 3.5rem;
    object-fit: cover;
    border-radius: .4rem;
    margin-right: 1rem;
    flex-shrink: 0
}

.more-product-name {
    flex: 1;
    font-size: 1rem;
    font-weight: 600;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}
</style>
